import formatFns from 'date-fns/format';
import { aiPhotoGenerationFolderId } from 'reactApp/modules/aiPhotoGeneration/aiPhotoGeneration.consts';
import { getDataFromStorage, saveDataToStorage } from 'reactApp/storage';
import type { TreeNodeData } from 'reactApp/ui/TreeComponent/TreeNode.types';

export const getAiPhotoGenerationImageFileName = (): string => {
    return formatFns(Date.now(), 'yyyy-mm-dd\u00A0hh.mm.ss');
};

export const checkAiPhotoGenerationExists = (folders: TreeNodeData[]) => folders.some((folder) => folder.id === aiPhotoGenerationFolderId);

class AiPhotoGenerationHelper {
    data: Uint8Array | null = null;

    saveImageData = (data: Uint8Array) => {
        this.data = data;
    };

    resetImageData = () => {
        this.data = null;
    };

    getImageData = () => this.data;
}

export const aiPhotoGenerationHelper = new AiPhotoGenerationHelper();

const storageKeyForAiGeneration = 'ai-generation-daily-requests';
const AI_GENERATION_TIME_RANGE = 24 * 60 * 60 * 1000;

const getActualAiGenerationRequests = () => {
    const now = Date.now();

    const raw = getDataFromStorage(storageKeyForAiGeneration);

    const requests = raw ? (Object.values(raw) as number[]) : raw;

    return requests.filter((t) => now - t < AI_GENERATION_TIME_RANGE);
};

export const canMakeAiGenerationRequest = (limit: number) => {
    const actual = getActualAiGenerationRequests();

    return actual.length < limit;
};

export const addAiGenerationRequest = (limit: number) => {
    const actual = getActualAiGenerationRequests();

    const updated = [...actual, Date.now()].slice(-limit);

    saveDataToStorage(storageKeyForAiGeneration, updated);
};

export const getNextAiGenerationTime = () => {
    const actual = getActualAiGenerationRequests();

    if (!actual.length) {
        return null;
    }

    return new Date(actual[0]).toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
    });
};
